





















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import useBlobUrl from "@/hooks/useBlobUrl";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInputFile from "@/components/BaseInputFile";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "InputMediaFile",

  components: { BaseIconButton, BaseInputFile, ImagePreview, BaseButton },
  props: {
    value: { type: [Object, File] as PropType<FileData | File> },
  },
  setup(props, { emit }) {
    const { getBlobUrl } = useBlobUrl();
    const src = computed(() => {
      if (props.value instanceof File) {
        return getBlobUrl(props.value);
      } else if (props.value) {
        return MediaFilesController.getImageThumbnail(props.value.urlPart, "1080p");
      }
      return null;
    });

    const onInput = (files: File[]) => {
      emit("input", files[0]);
    };

    return {
      src,
      onInput,
    };
  },
});
